import { gql } from "@apollo/client";

const SAVE_INFUSION_DROGAS_VISITA_CD = gql`
mutation SaveInfusionDrogasVisitaCD($input: InfusionDrogasCDInput!) {
  saveInfusionDrogasVisitaCD(input: $input) {
    idVisitaCD
  }
}`;

export const adaptInfusionDrogasCDInput = (data) => ({
  idVisita: data?.idVisita,
  infusionDrogas: !!data?.infusionDrogas,
  drogaAInfundir: data?.drogaAInfundir,
  dosis: data?.dosis,
  frecuencia: data?.frecuenciaDrogas,
  cumpleCriteriosIngreso: data?.cumpleCriteriosIngreso,
  infusionesPrevias: !!data?.infusionesPrevias,
  cantidadInfusionesPrevias: data?.cantidadInfusionesPrevias,
  lugarInfusionesPrevias: data?.lugarInfusionesPrevias,
  presentoReaccionesAdversas: data?.presentoReaccionesAdversas
});

export default SAVE_INFUSION_DROGAS_VISITA_CD;